import React from "react";
import QuickTalesContainer from "../../modules/OrganizationQuickTales/containers/QuickTalesContainer/QuickTalesContainer";

const QuickTalesInOrganization = () => {
  return <QuickTalesContainer />;
};

export default QuickTalesInOrganization;
